module.exports = __webpack_public_path__ + "img/got2.6971033a.png";